import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import * as LoginHelper from '../utils/LoginHelper';

const style = {
  height: '100%',
  width: '100%',
  margin: 0,
  padding:20,
  textAlign: 'center',
  display: 'inline-block',
};

export default
@observer class LoggedOutPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  login() {
    LoginHelper.login(this.context.router);
  }

  render() {
    return (
        <Paper style={style} zDepth={2}>
          {uiMsg('LO_LOGGED_OUT',"You have been logged out")}<br></br>
        <RaisedButton primary onClick={this.login.bind(this)}>
          {uiMsg('LO_LOG_IN',"Log in")}
        </RaisedButton>
        </Paper>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/LoggedOutPage.jsx
 **/